import apiClient from "../api/apiClient"

export interface BookerSyncStatus {
  id: string
  name: string
  email: string
  is_synced: boolean
  last_sync_date: string | null
  status: 'active' | 'inactive'
  daily_booking_count: number
}

export interface SyncStatusResponse {
  success: boolean
  data: {
    summary: {
      total: number
      synced: number
      pending: number
    }
    bookers: BookerSyncStatus[]
  }
}

export const syncService = {
  async getBookersSyncStatus(): Promise<SyncStatusResponse> {
    const response = await apiClient.get<SyncStatusResponse>("/admin/users/sync-status")
    return response.data
  },
}
